// extracted by mini-css-extract-plugin
export var container = "_fc-1";
export var cornerButtonContainer = "_fc-6";
export var disabled = "_fc-2";
export var dragActive = "_fc-3";
export var fileContainer = "_fc-5";
export var hiddenInput = "_fc-4";
export var widthContainer = "_fc-0";